import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { LuCircleAlert } from "react-icons/lu";

const P2pPopup = (props) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true)
    }, 3000)
    return () => clearTimeout(timer)
  }, [])
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Modal show={open} >
        <Modal.Body>
          {
            props.pageName == "p2p" ?
              <div className='d-flex flex-column align-items-center justify-content-center gap-3 p-3'>
                <span><LuCircleAlert size={50} /></span>
                <h2 className='fs-5'>
                  {/* TDS on Trading Crypto's */}
                  Stay Alert
                </h2>
                <p className='px-2 px-lg-4 text-center'>CoinDh will Only contact you through official emails, platforms, or the Appeals system for informational purpose or to request for the release/ cancellation of transaction funds Addionally. CoinDh does not engage third party custodial services to manage our assest.</p>
                
                <button className='w-100 p2ppop-btn' onClick={handleClose}>Ok</button>
              </div> :
              <div className='d-flex flex-column align-items-center justify-content-center gap-3 p-3'>
                <span><LuCircleAlert size={50} /></span>
                <h2 className='fs-5'>Stay Alert</h2>
                <p className='px-2 px-lg-4 text-center'>In accordance with goverment regulations, TDS of 1% (or 5% in certain cases) of trade value will be deducted on each trade on CoinDh begining July1, 2025. This TDS  can be claimed while submitting your ITR.</p>
                <button className='w-100 p2ppop-btn' onClick={handleClose}>Ok</button>
              </div>}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default P2pPopup;
